import { Fragment, useState } from "react";
import { toast } from "react-toastify";
import {
  PATCH_CREATE_SELLER_PRODUCT,
  POST_UPDATE_STOCK_STATUS,
} from "../../../../apis/configuration";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { ReactComponent as ChevronDown } from "../../../../assets/icons/chevron-down.svg";
import { camelCase } from "../../../../constants";
import { AppCheckbox, ParagraphText } from "../../../../Libraries";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { PopoverMenu } from "../../../common";
import { getVariantName } from "../../../../constants/variantConstants";
import galleryPlaceholder from "../../../../assets/images/galleryPlaceholder.png";
import { Box } from "@mui/material";
import styles from "./styles.module.css";
import { ArrowUpIcon, BackIcon, TickIcon } from "../../../../assets/icons/icon";
import ConfirmationModal from "../../../common/Modals/ConfirmationModal";

const ChevronRight = (props) => (
  <ChevronDown {...props} style={{ transform: "rotate(-90deg)" }} />
);

const ListItem = ({ data }) => {
  const {
    handleStockDetails,
    handleSelection,
    handleStock,
    publishList,
    stock,
    index,
    I18n,
  } = data || {};

  const {
    wholesale_price,
    approval_status,
    product_name,
    category,
    brand,
    id,
    out_of_stock,
  } = stock || {};

  const [publishModal, setPublishModal] = useState(false);
  const [variantIdToPub, setVariantIdToPub] = useState(null);
  const [variantModal, setVariantModal] = useState(false);
  const [showVariants, setShowVariants] = useState(false);
  const [stockModal, setstockModal] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(out_of_stock);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [loading, setLoading] = useState(false);

  const togglePublishModal = (toggle = false) => setPublishModal(toggle);
  const toggleVariantModal = () => setVariantModal((x) => !x);
  const toggleStockModal = (toggle = false) => setstockModal(toggle);

  const handlePublishStock = () => {
    setLoading(true);
    handleStock(PATCH_CREATE_SELLER_PRODUCT, {
      product_id: [id],
      publish: true,
    })
      .then(() => {
        togglePublishModal();
        toast.success("Stock publish successfully", {
          className: "successToast",
        });
      })
      .finally(() => setLoading(false));
  };

  const handleUpdateStockStatus = (action, product_info) => {
    triggerLogEvent(analytics, "sc_stock_item_status", {
      product_id: id,
      product_name: product_name,
      action,
    });
    setLoading(true);
    handleStock(POST_UPDATE_STOCK_STATUS, { action, product_info })
      .then(() => {
        toast.success("Stock status updated successfully", {
          className: "successToast",
        });
        toggleStockModal();
        setVariantIdToPub(null);
        setSelectedVariant(null);
        setCurrentStatus(out_of_stock);
      })
      .finally(() => setLoading(false));
  };

  const handlePublishVariant = () => {
    if (!variantModal) {
      toggleVariantModal();
    } else {
      setLoading(true);
      handleStock(PATCH_CREATE_SELLER_PRODUCT, {
        variant_id: [variantIdToPub],
        publish: true,
      })
        .then(() => {
          toggleVariantModal();
          toast.success("Variant published successfully", {
            className: "successToast",
          });
        })
        .finally(() => setLoading(false));
    }
  };

  const isPublishable =
    approval_status === "unpublished" || approval_status === "rejected";

  const menuOptions = [
    {
      label: (
        <Fragment>
          <BackIcon className={styles.backIcon} width="16px" height="16px" />
          <ParagraphText className="textCapitalizeFirstLetter">
            {out_of_stock ? I18n.mark_in_stock : I18n.mark_out_of_stock}
          </ParagraphText>
        </Fragment>
      ),
      action: (e) => {
        e.stopPropagation();
        toggleStockModal(true);
      },
    },
    ...(isPublishable
      ? [
          {
            label: (
              <Fragment>
                <TickIcon width="16px" height="16px" />
                <ParagraphText className="textCapitalizeFirstLetter">
                  {I18n.publish}
                </ParagraphText>
              </Fragment>
            ),
            action: (e) => {
              e.stopPropagation();
              togglePublishModal(true);
            },
          },
        ]
      : []),
  ];

  return (
    <>
      <Box
        onClick={(e) => {
          e?.preventDefault();
          triggerLogEvent(analytics, "sc_stock_item_click", {
            product_id: id,
            product_name: product_name,
          });
          handleStockDetails(stock);
        }}
        className={styles.tableRow}
        key={index}
      >
        <Box className={`${styles.col} ${styles.itemCol}`}>
          {stock?.variants?.length > 0 ? (
            <ChevronRight
              height={16}
              width={16}
              onClick={(e) => {
                e.stopPropagation();
                setShowVariants((c) => !c);
              }}
              className={`${styles.chevron} ${showVariants ? styles.chevronOpen : ""}`}
            />
          ) : (
            <Box className={styles.chevronPlaceholder} />
          )}

          <Box
            className={`${styles.checkboxWrap} checkboxCol`}
            onClick={(e) => e.stopPropagation()}
          >
            <AppCheckbox
              label=""
              onClick={() => handleSelection(id)}
              checked={!!publishList[id]}
            />
          </Box>

          <Box
            className={`${styles.productImage} ${
              !stock?.image_url ? styles.productPlaceholder : ""
            }`}
          >
            <img
              src={stock?.image_url || galleryPlaceholder}
              alt=""
              width="100%"
              height="100%"
            />
          </Box>

          <ParagraphText
            className="fontSize14 fontWeight400 newFontColor truncateOneLine"
            title={product_name}
          >
            {camelCase(product_name)}
          </ParagraphText>
        </Box>

        {/* SKU */}
        <Box className={`${styles.col} ${styles.skuCol}`}>
          <ParagraphText className="fontSize14 fontWeight400 newFontColor truncateOneLine">
            {id}
          </ParagraphText>
        </Box>

        {/* Category */}
        <Box className={`${styles.col} ${styles.categoryCol}`}>
          <ParagraphText
            className="fontSize14 fontWeight400 newFontColor truncateOneLine"
            title={category}
          >
            {camelCase(category)}
          </ParagraphText>
        </Box>

        {/* Brand */}
        <Box className={`${styles.col} ${styles.brandCol}`}>
          <ParagraphText
            className="fontSize14 fontWeight400 newFontColor truncateOneLine"
            title={brand}
          >
            {camelCase(brand || "-")}
          </ParagraphText>
        </Box>

        {/* Stock status */}
        <Box className={`${styles.col} ${styles.statusCol}`}>
          <ParagraphText
            className={`truncateOneLine ${out_of_stock ? styles.outOfStock : styles.inStock}`}
          >
            {out_of_stock ? I18n.out_of_stock : I18n.in_stock}
          </ParagraphText>
        </Box>

        {/* Visibility */}
        <Box className={`${styles.col} ${styles.visibilityCol}`}>
          <ParagraphText
            className={`truncateOneLine ${
              isPublishable ? styles.notPublished : styles.publishedText
            }`}
          >
            {isPublishable ? "Not published" : "Published"}
          </ParagraphText>
        </Box>

        {/* Price */}
        <Box className={`${styles.col} ${styles.priceCol}`}>
          <ParagraphText className="fontSize14 fontWeight400 newFontColor truncateOneLine">
            Rs.{" "}
            {!Boolean(stock?.variants?.length)
              ? formatNum(wholesale_price)
              : `${formatNum(stock?.min_sale_price || 0)} – ${formatNum(
                  stock?.max_sale_price || 0,
                )}`}
          </ParagraphText>
        </Box>

        {/* Actions */}
        <Box className={`${styles.col} ${styles.actionsCol}`}>
          <div className="tblOptnBox" role="button">
            <PopoverMenu
              id={`stock_item_${id}`}
              menuOptions={menuOptions}
              popOverStyle={{
                marginLeft: "5px",
                borderRadius: "16px !important",
              }}
            />
          </div>
        </Box>
      </Box>

      {showVariants && stock?.variants?.length
        ? stock.variants.map((varn, ind) => {
            const variantMenuOptions = [
              {
                label: (
                  <ParagraphText className="textCapitalizeFirstLetter">
                    {varn.out_of_stock ? I18n.in_stock : I18n.out_of_stock}
                  </ParagraphText>
                ),
                action: (e) => {
                  e.stopPropagation();
                  setVariantIdToPub(varn.id);
                  setSelectedVariant(getVariantName(varn?.attributes));
                  setCurrentStatus(varn.out_of_stock);
                  toggleStockModal(true);
                },
              },
            ];

            return (
              <Box key={`${id}-${ind}`} className={styles.variantRow}>
                <Box className={`${styles.col} ${styles.itemCol}`}>
                  {/* Mirror parent structure so name text starts at same x-position */}
                  <Box className={styles.chevronPlaceholder} />
                  <Box className={styles.productImagePlaceholder} />
                  <ParagraphText className="fontSize14 fontWeight400 newLightColor truncateOneLine">
                    {getVariantName(varn?.attributes)}
                  </ParagraphText>
                </Box>
                <Box className={`${styles.col} ${styles.skuCol}`}>
                  <ParagraphText className="fontSize14 fontWeight400 newFontColor truncateOneLine">
                    {varn.id}
                  </ParagraphText>
                </Box>
                <Box className={`${styles.col} ${styles.categoryCol}`}>
                  <ParagraphText className="fontSize14 fontWeight400 newFontColor truncateOneLine">
                    {camelCase(category)}
                  </ParagraphText>
                </Box>
                <Box className={`${styles.col} ${styles.brandCol}`}>
                  <ParagraphText className="fontSize14 fontWeight400 newFontColor truncateOneLine">
                    {camelCase(brand || "-")}
                  </ParagraphText>
                </Box>
                <Box className={`${styles.col} ${styles.statusCol}`}>
                  <ParagraphText
                    className={`truncateOneLine ${varn.out_of_stock ? styles.outOfStock : styles.inStock}`}
                  >
                    {varn.out_of_stock ? I18n.out_of_stock : I18n.in_stock}
                  </ParagraphText>
                </Box>
                <Box className={`${styles.col} ${styles.visibilityCol}`}>
                  <ParagraphText
                    className={`truncateOneLine ${varn.approval_status === "unpublished" || varn.approval_status === "rejected" ? styles.notPublished : styles.publishedText}`}
                  >
                    {varn.approval_status === "unpublished" ||
                    varn.approval_status === "rejected"
                      ? "Not published"
                      : "Published"}
                  </ParagraphText>
                </Box>
                <Box className={`${styles.col} ${styles.priceCol}`}>
                  <ParagraphText className="fontSize14 fontWeight400 newFontColor truncateOneLine">
                    Rs. {formatNum(varn.sale_price)}
                  </ParagraphText>
                </Box>
                <Box className={`${styles.col} ${styles.actionsCol}`}>
                  <div className="tblOptnBox" role="button">
                    <PopoverMenu
                      id={`variant_${varn.id}`}
                      menuOptions={variantMenuOptions}
                      popOverStyle={{
                        marginLeft: "5px",
                        borderRadius: "16px !important",
                      }}
                    />
                  </div>
                </Box>
              </Box>
            );
          })
        : null}

      <ConfirmationModal
        open={publishModal}
        onClose={() => togglePublishModal(false)}
        onConfirm={handlePublishStock}
        message={`Would you like to publish the "${product_name}" on your catalog?`}
        confirmText={I18n.confirm}
        cancelText={I18n.back}
        id="publish_item_modal"
        loading={loading}
        confirmButtonClassName="ubPrimaryButton"
      />

      <ConfirmationModal
        open={stockModal}
        onClose={() => toggleStockModal(false)}
        onConfirm={() => {
          handleUpdateStockStatus(out_of_stock ? "in-stock" : "out-of-stock", [
            {
              product_id: id,
              variant_ids: variantIdToPub ? [variantIdToPub] : [],
            },
          ]);
        }}
        message={`Would you like to mark the "${product_name} ${selectedVariant ? selectedVariant : ""}"  as ${out_of_stock ? "In stock" : "Out of stock"}?`}
        confirmText={I18n.confirm}
        cancelText={I18n.back}
        id="stock_list_item_update_stock_modal"
        loading={loading}
        confirmButtonClassName="ubPrimaryButton"
      />
    </>
  );
};

export default ListItem;
